import { render, staticRenderFns } from "./SkuFixedPeriodDetail.vue?vue&type=template&id=6b619aaf&scoped=true&"
import script from "./SkuFixedPeriodDetail.vue?vue&type=script&lang=js&"
export * from "./SkuFixedPeriodDetail.vue?vue&type=script&lang=js&"
import style0 from "./SkuFixedPeriodDetail.vue?vue&type=style&index=0&id=6b619aaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b619aaf",
  null
  
)

export default component.exports